'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitConsignment = exports.getSubmitConsignment = exports.SUBMIT_CONSIGNMENT_SUCCESS = exports.SUBMIT_CONSIGNMENT_REQUEST = exports.SUBMIT_CONSIGNMENT_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = require('../modules/user');

var _api = require('../api');

var _reselect = require('reselect');

var _config = require('../modules/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SUBMIT_CONSIGNMENT_FAIL = exports.SUBMIT_CONSIGNMENT_FAIL = 'la/user/consignment/FAIL';
var SUBMIT_CONSIGNMENT_REQUEST = exports.SUBMIT_CONSIGNMENT_REQUEST = 'la/user/consignment/REQUEST';
var SUBMIT_CONSIGNMENT_SUCCESS = exports.SUBMIT_CONSIGNMENT_SUCCESS = 'la/user/consignment/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SUBMIT_CONSIGNMENT_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                submitted: true,
                success: false
            });

        case SUBMIT_CONSIGNMENT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });

        case SUBMIT_CONSIGNMENT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false
            });

        default:
            return state;
    }
}

var submitConsignmentSelector = function submitConsignmentSelector(state) {
    return state.ui.consignment;
};

var getSubmitConsignment = exports.getSubmitConsignment = (0, _reselect.createSelector)(submitConsignmentSelector, function (consignment) {
    return consignment;
});

/* ACTION CREATORS */
var submitConsignment = exports.submitConsignment = function submitConsignment(form, file) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, userData;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            userData = (0, _user.getUserData)(state);

                            dispatch({
                                type: SUBMIT_CONSIGNMENT_REQUEST
                            });
                            _context.next = 8;
                            return _api.Consignment.postConsignment({ authToken: authToken, deployment: deployment, file: file, form: form, userData: userData });

                        case 8:
                            dispatch({
                                payload: form,
                                type: SUBMIT_CONSIGNMENT_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: SUBMIT_CONSIGNMENT_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/consignment.js
// module id = kcnD
// module chunks = 57